// src/context/ThemeContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import themes from '../theme/themes';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    // استرجاع الثيم المحفوظ من localStorage
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'vibrantPink';
  });

  const changeTheme = (themeId) => {
    setCurrentTheme(themeId);
    localStorage.setItem('theme', themeId);
  };

  const value = {
    currentTheme,
    changeTheme,
    theme: themes[currentTheme]?.theme || themes.vibrantPink.theme,
    themeData: themes[currentTheme] || themes.vibrantPink,
    allThemes: themes,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
